import React, { PureComponent, Fragment } from "react";
import { Icon } from "./Icon";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class Time extends PureComponent {
  static propTypes = {
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    userMetadata: {}
  };

  state = {
    time: ""
  };

  componentDidMount() {
    this.handleSetTime();
    this.interval = setInterval(this.handleSetTime, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleSetTime = () => {
    const { dateDisplayFormat = "YYYY-MM-DD" } = this.props.userMetadata;
    const localTime = moment().local();
    const time = `${localTime.format(`${dateDisplayFormat} | h:mm:ss a `)} (GMT${localTime.format("ZZ")})`;
    this.setState({ time });
  };

  render() {
    return (
      <div className="time">
        {this.state.time && (
          <Fragment>
            <Icon className="time__icon" id="clock" />
            {this.state.time}
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { userMetadata: state.app.userMetadata };
};

export default connect(mapStateToProps)(Time);



// WEBPACK FOOTER //
// ./src/components/Common/Time.js